import { defineMessages } from 'react-intl';

export default defineMessages({
  // unredeem modal
  unredeemSessionQuestion: {
    id: 'modules.documentTemplates.unredeemSessionQuestion',
    defaultMessage: 'Unredeem Session?',
  },
  unredeemSessionQuestionBody: {
    id: 'modules.documentTemplates.unredeemSessionQuestionBody',
    defaultMessage: 'Are you sure you want to unredeem item?',
  },
  unredeemSessionsQuestionBody: {
    id: 'modules.documentTemplates.unredeemSessionsQuestionBody',
    defaultMessage: 'Are you sure you want to unredeem {count} selected items?',
  },
  unredeemSessionsQuestion: {
    id: 'modules.documentTemplates.unredeemSessionsQuestion',
    defaultMessage: 'Unredeem Sessions?',
  },
  templateCreatedMessage: {
    id: 'app.modules.documentTemplates.templateCreatedMessage',
    defaultMessage: 'New document template has been created',
  },
});
